export class Constants {
  public static REQUEST_METHOD_GET = 'GET';
  public static REQUEST_METHOD_POST = 'POST';
  public static REQUEST_METHOD_PUT = 'PUT';

  public static LOCAL_STORAGE_TOKEN = 'ipt';
  public static LOCAL_STORAGE_USER_ID = 'iui';
}
